import * as PIXI from "pixi.js";
import {app, clickSound, events, gameData} from "../../utils/pixiApp";
import {Assets} from "pixi.js";
import {getDeviceMedia} from "../../utils/sizes";


const sizes = {
    web: {
        containerWidth: 258,
        containerHeight: 88,
        fontSize: 24,
        margin: 34,
    },
    mobile: {
        containerWidth: 167,
        containerHeight: 57,
        fontSize: 24,
        margin: 22,
    }
}

const textStyle = new PIXI.TextStyle({
    fontSize: sizes.web.fontSize,
    textTransform: 'uppercase',
    fontFamily: "MontserratBold, sans-serif",
    fontWeight: 'bold',
    fill: '#ffffff',
})

export class Button extends PIXI.Container {
    constructor(parentWidth, parentHeight) {
        super();
        this.media = getDeviceMedia(app.screen.width)
        this.wasStartedData = false;
        this.position.set(parentWidth / 2+ sizes[this.media].margin / 2, parentHeight / 2);
        this.pivot.set(.5, sizes[this.media].containerHeight / 2)

        this.button = new PIXI.Sprite(Assets.get('play'))
        this.button.setSize(sizes[this.media].containerWidth, sizes[this.media].containerHeight)

        this.addChild(this.button)

        events.onGameDataChange(this.onGameDataChange.bind(this))
        this.button.eventMode = 'static'
        this.button.cursor = 'pointer'

        this.button.on('pointerdown', this.onClick.bind(this))
        this.button.on('pointerover', this.onHover.bind(this))
        this.button.on('pointermove', this.onMove.bind(this))
        this.button.on('pointerout', this.onLeave.bind(this))
    }

    setSizes(width, height, media) {
        this.media = media
        this.position.set(width / 2 + sizes[this.media].margin / 2, height / 2);
        this.pivot.set(.5, sizes[this.media].containerHeight / 2)
        this.button.setSize(sizes[this.media].containerWidth, sizes[this.media].containerHeight)
    }

    onGameDataChange(eventArray) {
        if(eventArray.indexOf('finishAnimate') !== -1) {
            this.startGame = false
            if(gameData.getGameData('finishAnimate')) {
                this.button.texture = Assets.get('play')
                this.button.eventMode = 'static'
            }
        }
        if(eventArray.indexOf('speedUp') !== -1) {
            if(gameData.getGameData('speedUp')) {
                this.button.texture = Assets.get('turboDisabled')
                this.button.eventMode = 'none'
            }
        }
        if(eventArray.indexOf('startGame') !== -1) {
            this.button.eventMode = 'static'
            this.startGame = gameData.getGameData('startGame');
            if(this.startGame) {
                this.button.texture = Assets.get('turbo')
            }
        }
        if(eventArray.indexOf('gameOver') !== -1) {
            this.button.texture = Assets.get('playDisabled')
            this.button.eventMode = 'none'
            if(gameData.getGameData('prize') === 0) {
                setTimeout(() => {
                    this.button.eventMode = 'static'
                    this.button.texture = Assets.get('play')
                }, 600)
            }
        }
    }

    onClick() {
        this.sound()
        this.button.eventMode = 'none'
        if(this.startGame) {
            this.button.texture = PIXI.Texture.from('turboDisabled')
            if(!this.wasStartedData) {
                this.wasStarted()
            }
            setTimeout(() => {
                gameData.setGameDataByEvent('speedUp', true)
            }, 600)
        } else {
            this.button.texture = PIXI.Texture.from('playDisabled')
            gameData.setGameData('startGame', true)
        }
    }

    sound() {
        if(gameData.getGameData('sound')) {
            clickSound.play()
        }
    }

    wasStarted() {
        if(!gameData.getGameData('wasStarted')) {
            this.wasStartedData = true
            gameData.setGameData('wasStarted', true)
        }
    }
    onHover() {
        if(!this.startGame) {
            this.button.texture = PIXI.Texture.from('playHover')
        } else {
            this.button.texture = PIXI.Texture.from('turboHover')
        }
    }

    onMove() {
        if(!this.startGame && this.button.texture !== PIXI.Texture.from('playHover')) {
            this.button.texture = PIXI.Texture.from('playHover')
        } else if(this.startGame && this.button.texture !== PIXI.Texture.from('turboHover')) {
            this.button.texture = PIXI.Texture.from('turboHover')
        }
    }

    onLeave() {
        if(!this.startGame) {
            this.button.texture = PIXI.Texture.from('play')
        } else {
            this.button.texture = PIXI.Texture.from('turbo')
        }
    }
}